// @flow
import React, { useState, useEffect } from 'react';
import {
  MdCheck,
  MdEdit,
  MdClose,
  MdAdd,
} from 'react-icons/lib/md';

import Text from './text';
import Button from '../Button';
import styles from './userContactsForm.css';
import { getDefaultValue } from './utils';

type InputDefinitionType = {
  accessName: string,
  canEdit: boolean,
  hideOnEdit: boolean,
  componentType: string,
  highlight: boolean,
  placeholder?: string,
};

type RowProps = {
  value: any,
  inputsDefinition: Array<InputDefinitionType>,
  onChange: Function,
  remove: Function,
  onAdd: Function;
  isManually?: boolean;
};

const Row = ({
  value,
  inputsDefinition,
  onChange,
  remove,
  onAdd,
  isManually = false,
}: RowProps) => {
  const [rowValue, setRowValue] = useState(value || {});
  const [isEditing, setIsEditing] = useState(isManually || false);
  const [errors, setErrors] = useState({});

  const setRowValues = () => {
    if (isManually) {
      let tempValue = {};
      inputsDefinition.forEach((definition) => {
        tempValue[definition.accessName] = getDefaultValue(
          definition.componentType,
        );
      });
      setRowValue({ ...tempValue });
    }
  };

  useEffect(() => {
    setRowValues();
  }, []);

  const startEdition = () => {
    setIsEditing(true);
  };
  const endEdition = () => {
    setIsEditing(false);
  };

  const calculateInputs = () => {
    return inputsDefinition.map((definition) => {
      switch (definition.componentType) {
        case 'text':
          return (
            <Text
              value={rowValue[definition.accessName] || ''}
              isEditing={isEditing}
              canEdit={definition.canEdit}
              onDoubleClick={startEdition}
              error={errors[definition.accessName]}
              onChange={newValue => setRowValue({
                ...rowValue,
                [definition.accessName]: newValue,
              })}
              onEnter={endEdition}
              placeholder={definition.placeholder}
              highlight={definition.highlight}
            />
          );
        case 'image':
          return isManually || isEditing ? null : (
            <div className={styles.image}>
              <img
                src={rowValue[definition.accessName] || getDefaultValue('image')}
                alt="contactimage"
              />
            </div>
          );
        case 'hidden':
          return null;
        default:
          break;
      }
    });
  };

  return (
    <div className={styles.rowContainer}>
      <div className={`${styles.asRow} ${styles.inputsContainer}`}>
        {calculateInputs()}
      </div>
      {isEditing ? (
        <Button
          Icon={isManually ? MdAdd : MdCheck}
          onClick={() => {
            if (isManually && onAdd) {
              const validationResult = onAdd(rowValue);
              if (validationResult.canSave) setRowValues();
              setErrors(validationResult.errors);
            } else {
              const validationResult = onChange(rowValue);
              if (validationResult.canSave) setIsEditing(false);
              setErrors(validationResult.errors);
            }
          }}
        />
      ) : (
        <div className={`${styles.asRow}`}>
          <Button
            size="small"
            clearMargins
            onClick={startEdition}
            isTransparent
            Icon={MdEdit}
          />
          <Button
            size="small"
            clearMargins
            isTransparent
            Icon={MdClose}
            onClick={() => remove()}
          />
        </div>
      )}
    </div>
  );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scripts/components/UserContactsForm/row.jsx